export default __webpack_public_path__ + "static/media/CEDES-02.8c4e786d.jpg";